import Vue from 'vue'
import Febs from './FEBS'
import router from './router'
import Antd from 'ant-design-vue'
import store from './store'
import request from 'utils/request'
import db from 'utils/localstorage'
import VueApexCharts from 'vue-apexcharts'

import 'ant-design-vue/dist/antd.css'

import 'utils/install'



Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(db)
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.use({
  install (Vue) {
    Vue.prototype.$db = db
  }
})
import 'font-awesome/css/font-awesome.css'
import 'xe-utils'

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import './plugins/vxe-table/pro/vxe-table-pro.es6.min'
import './plugins/vxe-table/pro/vxe-table-pro.min.css'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/grid'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/legendScroll'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import VXETablePluginMenus from 'vxe-table-plugin-menus'
import VXETablePluginCharts from 'vxe-table-plugin-charts'
import 'vxe-table-plugin-charts/dist/style.css'
VXETable.use(VXETablePluginExportXLSX)
// 全局默认参数
VXETable.setup({
  version: 0, // 版本号，对于某些带数据缓存的功能有用到，上升版本号可以用于重置数据
  zIndex: 1000 // 全局 zIndex 起始值，如果项目的的 z-index 样式值过大时就需要跟随设置更大，避免被遮挡
})

Vue.use(VXETable)

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);



// 给 vue 实例挂载内部对象
// Vue.prototype.$XModal = VXETable.modal
// Vue.prototype.$XPrint = VXETable.print
// Vue.prototype.$XSaveFile = VXETable.saveFile
// Vue.prototype.$XReadFile = VXETable.readFile

// 安装快捷菜单插件
VXETable.use(VXETablePluginMenus, {
  // 给右键菜单的复制按钮设置为剪贴板操作函数
  // copy: XEClipboard.copy
})
// 安装图表插件
VXETable.use(VXETablePluginCharts)
















Vue.prototype.$postJson = request.postJson
Vue.prototype.$post = request.post
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(Febs)
}).$mount('#febs')



// WEBPACK FOOTER //
// ./src/main.js